export default __webpack_public_path__ + "static/media/tuhfahHome.9b06f271.png";